export function StockPrice({
  id = null,
  date = null,
  value = null,
  open = null,
  close = null,
  min = null,
  max = null,
  volume = null,
  change = null
}) {
  this._id = id
  this._date = date
  this._value = value
  this._open = open
  this._close = close
  this._min = min
  this._max = max
  this._volume = volume
  this._change = change
}

StockPrice.prototype.getId = function() {
  return this._id
}

StockPrice.prototype.setId = function(id) {
  this._id = id
}

StockPrice.prototype.getDate = function() {
  return this._date
}

StockPrice.prototype.setDate = function(date) {
  this._date = date
}

StockPrice.prototype.getValue = function() {
  return this._value
}

StockPrice.prototype.setValue = function(value) {
  this._value = value
}

StockPrice.prototype.getOpen = function() {
  return this._open
}

StockPrice.prototype.setOpen = function(open) {
  this._open = open
}

StockPrice.prototype.getClose = function() {
  return this._close
}

StockPrice.prototype.setClose = function(close) {
  this._close = close
}

StockPrice.prototype.getMin = function() {
  return this._min
}

StockPrice.prototype.setMin = function(min) {
  this._min = min
}

StockPrice.prototype.getMax = function() {
  return this._max
}

StockPrice.prototype.setMax = function(max) {
  this._max = max
}

StockPrice.prototype.getVolume = function() {
  return this._volume
}

StockPrice.prototype.setVolume = function(volume) {
  this._volume = volume
}

StockPrice.prototype.getChange = function() {
  return this._change
}

StockPrice.prototype.setChange = function(change) {
  this._change = change
}

// StockPrice.prototype.getTimestamp = function() {
//   return this._timestamp
// }

// StockPrice.prototype.setTimestamp = function(timestamp) {
//   this._timestamp = timestamp
// }

// StockPrice.prototype.getIsFetching = function() {
//   return this._isFetching
// }

// StockPrice.prototype.setIsFetching = function(isFetching) {
//   this._isFetching = isFetching
// }



// WEBPACK FOOTER //
// ./src/custom/entities/index.js